const formatMap = {
  "YYYY-MM-DD": /\d{4}-\d{2}-\d{2}/,
};

export function extractDateFromString(
  text: string | null | undefined,
  format: keyof typeof formatMap = "YYYY-MM-DD"
): string | null | undefined {
  return (text || "").match(formatMap[format])?.[0] || text;
}
